import React from 'react';

export const Loading = (shouldShow) => {
  return (
    <div className='loader-box'>
      <div className='loader-37'></div>
    </div>
  );
};
